import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { IAuditPagedRequest } from '../../../../model/apm/audit/request/audit-paged-request';
import { IAuditAddEditRequest } from '../../../../model/apm/audit/request/audit-add-edit-request';
import { IAuditResponse } from '../../../../model/apm/audit/response/audit-response';

const defaultPath = 'Audit';

// Paginação 0-based; a API limita PageSize a 100
const list = async (params: IAuditPagedRequest): Promise<Pagination<IAuditResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: {
            Term: params.term || undefined,
            Year: params.year,
            Status: params.status,
            InspectionBody: params.inspectionBody,
            Page: params.page,
            PageSize: params.pageSize,
        }
    }).then((response) => Object.assign(new Pagination<IAuditResponse>(), response.data));
};

const getById = async (id: number): Promise<IAuditResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: IAuditAddEditRequest): Promise<IAuditResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: IAuditAddEditRequest): Promise<IAuditResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const AuditAppService = { list, getById, add, edit, remove };
export default AuditAppService;
